import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';
import _ from 'lodash';
import { Collection } from "backbone";
import moment from "moment";
import MatchCentreGameBarRounds from "./MatchCentreGameBarRounds";
import $ from "jquery";
import Radio from 'backbone.radio';


const matchCentreGameBarChannel = Radio.channel('matchCentreGameBar');
export class MatchCentreGameBar extends View {
	get template() {
		return template;
	}

	regions() {
		return {
			matches: '.js-matches-wrapper',
		}
	}

	get className() {
		return 'match-centre-game-bar';
	}

	ui() {
		return {
			prev: '.js-prev',
			next: '.js-next'
		}
	}

	events() {
		return {
			'click @ui.prev': 'scrollPrev',
			'click @ui.next': 'scrollNext'
		}
	}

	initialize() {
		this.$active = [];
		this.initListeners()
			.initLayouts()
			.requestData();
	}

	initListeners() {
		this.listenTo(matchCentreGameBarChannel, 'route:changed', this.checkUser);
		this.listenTo(this, 'main:data:requested', this.onMainDataRequested);
		this.listenTo(this, 'rounds:updated', this.updateData);

		return this;
	}

	initLayouts() {
		this.initLayout('matches', new MatchCentreGameBarRounds({
			collection: new Collection(this.options.rounds)
		}));
		return this;
	}

	initLayout(region, view) {
		if (!this.getRegion(region).hasView()) {
			this.showChildView(region, view);
		}

		return this;
	}

	get requestModels() {
		return _.pick(
			this.options,
			'squads', 'rounds', 'ladder'
		);
	}

	async requestData() {

		const requests = _.invokeMap(this.requestModels, 'fetch');

		await Promise.all(requests);

		this.trigger('main:data:requested');

		return this;
	}

	setSelectedRound() {
		this.selected_round = this.options.rounds.getActualRound();

		this.round_id = this.selected_round.get('id');

		return this;
	}

	updateMatches() {
		const ladder = this.options.ladder.toJSON();
		this.options.rounds.each(round => {
			round.setMatchDates();
			const matches = _.map(round.get('matches'), match => {
				match.home_ladder_place = _.findIndex(ladder, { id: match.home_squad_id }) + 1;
				match.away_ladder_place = _.findIndex(ladder, { id: match.away_squad_id }) + 1;
				match.date = moment(match.date).format('ddd MMM D');
				return match;
			});
			round.set({
				matches
			});
		});


		return this;

	}

	onMainDataRequested() {
		this.setSelectedRound()
			.checkRoundStatus()
			.updateMatches()
			.initChild();
		return this;
	}

	updateData() {
		this.setSelectedRound()
			.checkRoundStatus()
			.updateMatches()
			.getChildView('matches').init({
				rounds: this.options.rounds.toJSON(),
				selected: this.round_id
			});

		this.setCurrent();

		return this;
	}

	initChild() {
		this.getChildView('matches').init({
			rounds: this.options.rounds.toJSON(),
			selected: this.round_id
		});

		this.scrollToCurrent();
		return this;
	}

	checkRoundStatus() {
		if (this.selected_round.is_active) {
			this.subscribeToLiveUpdates();
		}
		else if (this.liveScoresIntervalId) {
			this.unsubscribeFromLiveUpdates();
		}
		return this;
	}

	subscribeToLiveUpdates() {
		clearTimeout(this.liveScoresIntervalId);

		let time = this.selected_round.active_match ? .5 : 5;

		this.liveScoresIntervalId = setTimeout(async () => {
			await this.options.rounds.fetch();
			this.trigger('rounds:updated');
		}, time * 1000 * 60);
		return this;
	}

	unsubscribeFromLiveUpdates() {
		clearTimeout(this.liveScoresIntervalId);
	}

	scrollPrev() {
		const $element = $('.js-rounds');
		const $active = $element.find('.active');
		const current_offset = $active.position().left;
		const $prev = $active.prev();
		const $prev_prev = $active.prev().prev();
		$active.removeClass('active');

		if (!$prev.length || !$prev_prev.length) {
			$('.match-centre-game-bar-match').first().addClass('active');
			return this.scrollWrapper({
				offset: 0
			});
		}


		let offset = current_offset - $prev.width();
		if (offset !== $prev_prev.width()) {
			offset -= $prev_prev.width();
			$prev_prev.addClass('active');
		}
		else {
			$prev.addClass('active');
		}

		this.scrollWrapper({
			offset
		});
	}

	scrollNext() {
		const $element = $('.js-matches-wrapper');
		const $active = $element.find('.active');
		const current_offset = $active.position().left;
		const $next = $active.next();
		const $next_next = $active.next().next();
		$active.removeClass('active');
		if (!$next.length || !$next_next.length) {
			$('.match-centre-game-bar-match').last().addClass('active');
			return this.scrollWrapper({
				offset: 0
			});
		}
		let offset = current_offset + $next.width();
		if (offset !== $next_next.width()) {
			offset += $next_next.width();
			$next_next.addClass('active');
		}
		else {
			$next.addClass('active');
		}

		this.scrollWrapper({
			offset
		});
	}

	scrollToCurrent() {
		const $selected = this.$el.find(`.js-round-id-${this.round_id}`);

		$selected.addClass('active');
		if ($selected) {
			const offset = $selected.position().left;

			this.scrollWrapper({ offset });
		}

	}

	setCurrent() {

		const $element = $('.js-rounds');
		const $active = $element.find('.active');
		if (!$active.length) {
			const $selected = this.$el.find(`.js-round-id-${this.round_id}`);
			$selected.addClass('active');
		}

		return this;
	}

	scrollWrapper({ offset }) {
		$('.js-matches-wrapper').animate({ scrollLeft: offset }, 200);
	}

	checkUser({ is_authorized, name }) {
		if (!is_authorized || [
			'gameSelector', 'activateGame', 'home', 'onboarding',
			'passwordChange', 'passwordChangeConfirmation'
		].includes(name)) {
			this.$el.css({ display: 'none' });
		}
		else {
			this.$el.css({ display: 'flex' });
		}
	}
}

export default MatchCentreGameBar;